<template>
  <div class="question-timeline">
    <div class="question-timeline-bar" :style="{ width: (index / count) * 100 + '%' }"></div>
    <div class="question-timeline-text" :style="{ left: (index / count) * 100 + '%' }">
      <span v-if="index > 0">{{ Math.round((index / count) * 100) + '%' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      progress: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.progressBar {
  width: 100%;
  position: relative;
  background: #ebe5da;
  height: 7px;
  border-radius: 3px;
  .progress {
    position: absolute;
    left: 0;
    height: 7px;
    border-radius: 3px;
    background: #f04e23;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProgressBar.vue